import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import InterventionForm from "../../components/InterventionForm";

interface AddAssessmentModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (data: any) => void;
    patientId: string;  // Tambahkan patientId
}

const AddAssessmentModal: React.FC<AddAssessmentModalProps> = ({ isOpen, onClose, onSubmit, patientId }) => {
    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" open={isOpen} onClose={onClose}>
                <div className="fixed inset-0 z-[999] overflow-y-auto bg-black/60">
                    <div className="flex min-h-screen items-center justify-center px-4">
                        <Dialog.Panel className="panel my-8 w-full max-w-lg overflow-hidden rounded-lg p-0 text-black dark:text-white-dark">
                            <div className="flex items-center justify-between bg-[#fbfbfb] px-5 py-3 dark:bg-[#121c2c]">
                                <h5 className="text-lg font-bold">Add Assessment</h5>
                                <button type="button" className="text-white-dark hover:text-dark" onClick={onClose}>
                                    ❌
                                </button>
                            </div>
                            <div className="p-5">
                                <InterventionForm onSubmit={onSubmit} patientId={patientId} />
                            </div>
                        </Dialog.Panel>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
};
export default AddAssessmentModal;
